export default __webpack_public_path__ + "static/media/login-bg.9013d537.jpg";